const checkedSessionSatate = {
    checkedSession: "",
    loading: false,
    error: null
  };
  
  const checkedSessionReducer = (state = checkedSessionSatate, action) => {
    switch (action.type) {
      case 'FETCH_CHECKEDSESSION_REQUEST':
        return {
          ...state,
          loading: true,
          error: null
        };
      case 'FETCH_CHECKEDSESSION_SUCCESS':
    
        return {
          ...state,
          loading: false,
          checkedSession: action.payload
        };
        
      case 'FETCH_CHECKEDSESSION_FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      default:
        return state;
    }
  };
  
  export default checkedSessionReducer;
  